'use client';

import { ArticleContentBox } from '@/app/(site)/(framed)/privacy-policy-of-your-existence/components/ArticleContentBox';
import { Box, Button, Flex, Paper, Typography } from '@/ui';
import type { FC } from 'react';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

export const TruthButton: FC = () => {
  const { revealed, setRevealed } = useTruth();

  const revealTheTruth = () => {
    setRevealed(true);
  };

  return (
    <ArticleContentBox marginTop={40} marginBottom={40}>
      <Paper padding={24}>
        <Flex
          flexDirection="column"
          alignContent="center"
          alignItems="center"
          justifyContent="center"
        >
          <Box marginBottom={24} maxWidth={400}>
            <Typography.Caption size="L" textAlign="center">
              {messages['revealTheTruth.text']}
            </Typography.Caption>
          </Box>

          <Button
            size="S"
            variant="solid"
            disabled={revealed}
            onClick={revealTheTruth}
            frameAnimation={!revealed ? 'pulsing' : 'none'}
          >
            {!revealed
              ? messages['revealTheTruth.button']
              : messages['revealTheTruth.button.disabled']}
          </Button>
        </Flex>
      </Paper>
    </ArticleContentBox>
  );
};
